// React
import React, { Component } from 'react';
import {ButtonGroup} from '@material-ui/core/';
import {functions} from 'constants/index';
import {Description, Close} from '@material-ui/icons/';
// Api Services
import ApiServices from 'services/ApiServices';
// Redux
import LoadingIndicator  from 'commons/LoadingIndicator';

import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
// componentes
import Table from 'components/Table';
import BotonElement from 'components/BotonTable'; 
import Footer from 'pages/Home/Footer2';
import CrearSolicitud from './SolicitudesEmpadronamiento';
import AutorizarSolicitudesEmpadronamientoExtranjero from './SolicitudesEmpadronamiento/';
import LoadingSpinner from 'components/LoadingSpinner';

import {showMessageSuccessSimple, showMessageErrorSimple, showMessageError} from 'services/SweetAlert'

class SolicitudesNuevasExtranjero extends Component {     
    constructor(props) {
        super(props);
        this.state = {
            SOLICITUD_EMPADRONAMIENTO_SET_DATOS_SOLICITUD_RENAP: props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_SOLICITUD_RENAP,
            SOLICITUD_EMPADRONAMIENTO_SET_DATOS_IDENTIDAD: props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_IDENTIDAD,
            esRechazadoOEmpadronado: props.esRechazadoOEmpadronado,
            controller:'solicitudesDeEmpadronamiento',
            loading: false,
            loadingCargarFotosDeIdentidad:false,
            authorized:true,
            checkAutorization:true,
            aceptarOpen: false,
            rechazarOpen: false,
            newCve:"",
            abrirModalAceptarSolicitud: false,
            abrirModalRechazoSolicitud: false,
            datosPadron:{},
            rowData: [],
            data: [],
            cuiDPI:'',
            customActions:[],
            header: [
                { title: 'Solicitud No.', field: 'datosSolicitudEmpadronamiento.idSolicitud',cellStyle:{ maxWidth: '80px' } },
                { title: 'Nombre Completo', field: 'nombreCompleto', cellStyle:{ maxWidth: '100px' }},
                { title: 'CUI', field: 'datosDpiSolicitudEmpadronamiento.cui' },
                { title: 'Correo', field: 'complementoSolicitudesEmpadronamiento.email' },
                { title: 'Teléfono', field: 'complementoSolicitudesEmpadronamiento.telefono' },                
                { title: 'Fecha de solicitud', field: 'datosSolicitudEmpadronamiento.fechaSolicitud', render: (rowData) => functions.splitDate(rowData.datosSolicitudEmpadronamiento.fechaSolicitud)},
                { title: 'Acción', field: 'accion',
                    render: rowData=><div>
                    {
                        <ButtonGroup color="primary" aria-label="outlined primary button group">
                            <BotonElement icon={<Description />} title="Procesar Solicitud" function={() => this.AbrirModalAprobarSolicitudEmpadronamientoModal(rowData)}/>
                            {/* <BotonElement icon={<Close />} title="Rechazar solicitud" function={() => this.AbrirModalRechazarSolicitudEmpadronamientoModa(rowData)}/> */}
                        </ButtonGroup>
                    }  
                    </div>            
                }, 
            ],
            currentUser: props.currentUser,
            datosIdentidad: [
                { tipo:'Fotografía', nombreCompleto:'', nombreCompletoPrueba:'', primerNombre:'', segundoNombre:'', primerApellido:'', segundoApellido:'', tercerApellido:'', foto: '', fechaNacimiento: '', width: 480, height: 640},
                { tipo:'Firma', foto: '', width: 300, height: 100},
                { tipo:'Huella', foto: '', width: 416, height: 416},
            ],
            fotosVieneVacio:false,
            mensajeFotosVieneVacio:'',
            datosEmpadronador:{},
            showModalNewCensusRegistration: false,
        }
    //declaraciones de todas las funciones que se utilizaran
        this.showList = this.showList.bind(this);   
        this.AbrirModalAprobarSolicitudEmpadronamientoModal = this.AbrirModalAprobarSolicitudEmpadronamientoModal.bind(this);
        this.CerrarModalSolicitudEmpadronamientoModal = this.CerrarModalSolicitudEmpadronamientoModal.bind(this);
        
        this.AbrirModalRechazarSolicitudEmpadronamientoModa = this.AbrirModalRechazarSolicitudEmpadronamientoModa.bind(this);
        this.CerrarModalRechazoDeSolicitudEmpadronamientoModal = this.CerrarModalRechazoDeSolicitudEmpadronamientoModal.bind(this);
        this.ObtenerDatosEmpadronador = this.ObtenerDatosEmpadronador.bind(this);
        this.openModalForNewCensusRegistration = this.openModalForNewCensusRegistration.bind(this);
        this.closeModalForNewCensusRegistration = this.closeModalForNewCensusRegistration.bind(this);
    }
    //obtenemos los datos del empadronador para mostrarlo en pantalla
    async ObtenerDatosEmpadronador(){
        try{
            let response = await ApiServices.solicitudesDeEmpadronamiento.usuariosGeo();
            if(response.error){
                showMessageErrorSimple('¡Oops!','Error al obtener los datos del usuario.')
            }else {
                var datos = response.data
                this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_EMPADRONADOR(datos)
            } 
        }catch(exception){
            (exception.status===404) ? showMessageErrorSimple("Falla del sistema"): showMessageErrorSimple('¡Oops!',exception.message);
        }                
    }
    //abrimos el modal para aprobar solicitudes de empadronamiento
    async AbrirModalAprobarSolicitudEmpadronamientoModal(data){ 
        this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_IDENTIDAD([])                
        this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_SOLICITUD_RENAP(data.datosSolicitudEmpadronamiento.idSolicitud)
        this.props.SOLICITUD_EMPADRONAMIENTO_SET_CUI_DPI(data.datosDpiSolicitudEmpadronamiento.cui)            
        // this.props.SOLICITUD_EMPADRONAMIENTO_SET_CUI_DPI(3280804031101)            
        // this.props.SOLICITUD_EMPADRONAMIENTO_SET_ES_RECHAZADO_O_EMPADRONADO(false)
        this.setState({loadingCargarFotosDeIdentidad: true})
        try{
            // const response =  await ApiServices.verificarSolicitudDeEmpadronamiento.validarIdentidad(data.datosDpiSolicitudEmpadronamiento.cui);
            const response =  await ApiServices.verificarSolicitudDeEmpadronamiento.validarIdentidad(data.datosDpiSolicitudEmpadronamiento.cui);
            // const response =  await ApiServices.verificarSolicitudDeEmpadronamiento.validarIdentidad('1997885610101');
            // const response =  await ApiServices.verificarSolicitudDeEmpadronamiento.validarIdentidad('2937443351101');
            if(response.error!==null){
                if(data.primerNombre === null) this.state.datosIdentidad[0].primerNombre = "";
                else this.state.datosIdentidad[0].primerNombre = data.primerNombre;

                if(data.segundoNombre === null) this.state.datosIdentidad[0].segundoNombre = "";
                else this.state.datosIdentidad[0].segundoNombre = data.segundoNombre;

                if(data.primerApellido === null) this.state.datosIdentidad[0].primerApellido = "";
                else this.state.datosIdentidad[0].primerApellido = data.primerApellido;

                if(data.segundoApellido === null) this.state.datosIdentidad[0].segundoApellido = "";
                else this.state.datosIdentidad[0].segundoApellido = data.segundoApellido;

                if(data.tercerApellido === null) this.state.datosIdentidad[0].tercerApellido = "";
                else this.state.datosIdentidad[0].tercerApellido = data.tercerApellido;                
                // const response =  await ApiServices.verificarSolicitudDeEmpadronamiento.validarIdentidad('3280804031101');
                this.state.datosIdentidad[0].nombreCompletoPrueba = this.state.datosIdentidad[0].primerNombre+' '+ this.state.datosIdentidad[0].segundoNombre+', '+ this.state.datosIdentidad[0].primerApellido+' '+ this.state.datosIdentidad[0].segundoApellido+', '+this.state.datosIdentidad[0].tercerApellido
                this.state.datosIdentidad[0].nombreCompleto = data.primerNombre+' '+ data.segundoNombre+', '+ data.primerApellido+' '+ data.segundoApellido+', '+data.tercerApellido
                this.state.datosIdentidad[0].fechaNacimiento = data.fechaNacimiento

                this.state.datosIdentidad[0].foto = "/assets/noImagen.svg"; this.state.datosIdentidad[0].width = 300; this.state.datosIdentidad[0].height = 400
                this.state.datosIdentidad[1].foto = "/assets/noImagen.svg"; this.state.datosIdentidad[1].width = 300; this.state.datosIdentidad[1].height = 400
                this.state.datosIdentidad[2].foto = "/assets/noImagen.svg"; this.state.datosIdentidad[2].width = 300; this.state.datosIdentidad[2].height = 400
                this.setState({fotosVieneVacio: true, mensajeFotosVieneVacio: response.error.message, loadingCargarFotosDeIdentidad:false,});                    
                // showMessageErrorSimple('Oops!', response.error.message)
            }else{                                       
                if(data.primerNombre === null) this.state.datosIdentidad[0].primerNombre = "";
                else this.state.datosIdentidad[0].primerNombre = data.primerNombre;

                if(data.segundoNombre === null) this.state.datosIdentidad[0].segundoNombre = "";
                else this.state.datosIdentidad[0].segundoNombre = data.segundoNombre;

                if(data.primerApellido === null) this.state.datosIdentidad[0].primerApellido = "";
                else this.state.datosIdentidad[0].primerApellido = data.primerApellido;

                if(data.segundoApellido === null) this.state.datosIdentidad[0].segundoApellido = "";
                else this.state.datosIdentidad[0].segundoApellido = data.segundoApellido;

                if(data.tercerApellido === null) this.state.datosIdentidad[0].tercerApellido = "";
                else this.state.datosIdentidad[0].tercerApellido = data.tercerApellido;

                this.state.datosIdentidad[0].nombreCompletoPrueba = this.state.datosIdentidad[0].primerNombre+' '+ this.state.datosIdentidad[0].segundoNombre+', '+ this.state.datosIdentidad[0].primerApellido+' '+ this.state.datosIdentidad[0].segundoApellido+', '+this.state.datosIdentidad[0].tercerApellido
                this.state.datosIdentidad[0].nombreCompleto = data.primerNombre+' '+ data.segundoNombre+', '+ data.primerApellido+' '+ data.segundoApellido+', '+data.tercerApellido
                this.state.datosIdentidad[0].fechaNacimiento = data.fechaNacimiento
                this.state.datosIdentidad[0].foto = 'data:image/jpeg;base64,'+ response.data.object.fotoCiudadano; this.state.datosIdentidad[0].width = 300; this.state.datosIdentidad[0].height = 400
                this.state.datosIdentidad[1].foto = 'data:image/jpeg;base64,'+ response.data.object.firmaCiudadano; this.state.datosIdentidad[1].width = 300; this.state.datosIdentidad[1].height = 100
                this.state.datosIdentidad[2].foto = 'data:image/jpeg;base64,'+ response.data.object.huellaCiudadano; this.state.datosIdentidad[2].width = 300; this.state.datosIdentidad[2].height = 390
                this.setState({fotosVieneVacio: false, mensajeFotosVieneVacio:'',loadingCargarFotosDeIdentidad:false,});
            }   
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_IDENTIDAD(this.state.datosIdentidad)
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_CIUDADANO_TABLE(data)
            this.setState({abrirModalAceptarSolicitud:true, });
            this.setState({loadingCargarFotosDeIdentidad: false})
        }catch(exception){                
            this.setState({loadingCargarFotosDeIdentidad: false})
            if (exception.status===404) {
                showMessageError('Oops!','Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.')
            }
            else {
                showMessageError('Oops!','Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.')
            }
        }            
    }
    CerrarModalSolicitudEmpadronamientoModal(){ this.setState({abrirModalAceptarSolicitud:false}); }
    //abrimos el modal para rechazar solicitudes de empadronamiento
    async AbrirModalRechazarSolicitudEmpadronamientoModa(data){ 
        this.props.SOLICITUD_EMPADRONAMIENTO_SET_ES_RECHAZADO_O_EMPADRONADO(false)
        this.setState({loadingCargarFotosDeIdentidad: true})
        this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_IDENTIDAD([])                
        this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_CIUDADANO_TABLE(data)
        this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_SOLICITUD_RENAP(data.datosSolicitudEmpadronamiento.idSolicitud)
        // this.setState({abrirModalRechazoSolicitud:true, });                               
        try{
            const response =  await ApiServices.verificarSolicitudDeEmpadronamiento.validarIdentidad(data.datosDpiSolicitudEmpadronamiento.cui);
            if(data.primerNombre === null) this.state.datosIdentidad[0].primerNombre = "";
            else this.state.datosIdentidad[0].primerNombre = data.primerNombre;

            if(data.segundoNombre === null) this.state.datosIdentidad[0].segundoNombre = "";
            else this.state.datosIdentidad[0].segundoNombre = data.segundoNombre;

            if(data.primerApellido === null) this.state.datosIdentidad[0].primerApellido = "";
            else this.state.datosIdentidad[0].primerApellido = data.primerApellido;

            if(data.segundoApellido === null) this.state.datosIdentidad[0].segundoApellido = "";
            else this.state.datosIdentidad[0].segundoApellido = data.segundoApellido;

            if(data.tercerApellido === null) this.state.datosIdentidad[0].tercerApellido = "";
            else this.state.datosIdentidad[0].tercerApellido = data.tercerApellido;                
            // const response =  await ApiServices.verificarSolicitudDeEmpadronamiento.validarIdentidad('3280804031101');
            this.state.datosIdentidad[0].nombreCompletoPrueba = this.state.datosIdentidad[0].primerNombre+' '+ this.state.datosIdentidad[0].segundoNombre+', '+ this.state.datosIdentidad[0].primerApellido+' '+ this.state.datosIdentidad[0].segundoApellido+', '+this.state.datosIdentidad[0].tercerApellido
            this.state.datosIdentidad[0].nombreCompleto = data.primerNombre+' '+ data.segundoNombre+', '+ data.primerApellido+' '+ data.segundoApellido+', '+data.tercerApellido
            this.state.datosIdentidad[0].fechaNacimiento = data.fechaNacimiento
            if(response.error!==null){
                this.state.datosIdentidad[0].foto = "/assets/noImagen.svg"; this.state.datosIdentidad[0].width = 480; this.state.datosIdentidad[0].height = 640
                this.state.datosIdentidad[1].foto = "/assets/noImagen.svg"; this.state.datosIdentidad[1].width = 480; this.state.datosIdentidad[1].height = 640
                this.state.datosIdentidad[2].foto = "/assets/noImagen.svg"; this.state.datosIdentidad[2].width = 480; this.state.datosIdentidad[2].height = 640
                this.setState({abrirModalRechazoSolicitud:true, fotosVieneVacio: true, mensajeFotosVieneVacio: response.error.message, loadingCargarFotosDeIdentidad:false,});
            }else{                
                this.state.datosIdentidad[0].foto = 'data:image/jpeg;base64,'+ response.data.object.fotoCiudadano; this.state.datosIdentidad[0].width = 480; this.state.datosIdentidad[0].height = 640
                this.state.datosIdentidad[1].foto = 'data:image/jpeg;base64,'+ response.data.object.firmaCiudadano; this.state.datosIdentidad[1].width = 300; this.state.datosIdentidad[1].height = 100
                this.state.datosIdentidad[2].foto = 'data:image/jpeg;base64,'+ response.data.object.huellaCiudadano; this.state.datosIdentidad[2].width = 416; this.state.datosIdentidad[2].height = 416
                this.setState({abrirModalRechazoSolicitud:true, fotosVieneVacio: false, mensajeFotosVieneVacio:'',loadingCargarFotosDeIdentidad:false,});
            }   
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_IDENTIDAD(this.state.datosIdentidad)
        }catch(exception){
            this.setState({loadingCargarFotosDeIdentidad:false})
            if (exception.status===404) {
                showMessageError('Oops!','Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.')
            }
            else {
                showMessageError('Oops!','Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.')
            }
        }            
    }
    async CerrarModalRechazoDeSolicitudEmpadronamientoModal(){ 
        if(this.props.esRechazadoOEmpadronado===true){
            this.showList();                 
        }
        this.setState({abrirModalRechazoSolicitud:false});
    }
// cargamos todas las solicitudes de renap en la tabla
    async showList(){
        try{
            this.setState({loading: true, checkAutorization: true});
            const hasPermission = await ApiServices.userSecurity.hasPermission('solicitudesDeEmpadronamiento','list');    
            if (hasPermission.error){
                this.setState({checkAutorization: false,authorized: false,loading: false });
            }else{
                ApiServices[this.state.controller].initSearchCriteria.clear();
                ApiServices[this.state.controller].initSearchCriteria.setOperator("and");
                ApiServices[this.state.controller].initSearchCriteria.addEquals("datosSolicitudEmpadronamiento.statusSolicitud", 0);  
                ApiServices[this.state.controller].initOrderCriteria.addAsc("datosSolicitudEmpadronamiento.idSolicitud");
                this.setState({checkAutorization: false, authorized: true,loading: false,data: [], create: false });
            }
        }catch(exception){
            if(exception.status===404) {
                showMessageError('Oops!','Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.')
            }else {
                showMessageError('Oops!','Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.');
            }
            this.setState({ loading: false,checkAutorization: false, data:[]});
        }
    }

    async componentDidMount() {  
        this.showList();
        this.ObtenerDatosEmpadronador();
    }
    componentDidUpdate() {
        if(this.props.esRechazadoOEmpadronado){
            this.showList(); 
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_ES_RECHAZADO_O_EMPADRONADO(false)
        }
    }    

      //abrimos el modal para aprobar solicitudes de empadronamiento
    async openModalForNewCensusRegistration(){ 
        this.setState({showModalNewCensusRegistration : true});
    }
    async closeModalForNewCensusRegistration(){ 
        this.setState({showModalNewCensusRegistration : false}); 
        this.props.SET_DATA_IS_REGISTERED({})
        this.props.CLEAR_DATA_DATOS_IDENTIDAD();  
        this.props.CLEAR_DATA_DATOS_IDENTIDAD_DEL_CIUDADANO();
    }

    
    render() {
        if (this.state.checkAutorization ) return <LoadingSpinner open={this.state.loading}/> 
        // if (!this.state.authorized &&  !this.state.loading){ return <NotAuthorized/>}
        return (
            <div>
                {this.state.loading ? <LoadingSpinner open={this.state.loading}/> : ""}
                <LoadingSpinner open={this.state.loadingCargarFotosDeIdentidad}/>
                <CrearSolicitud 
                    actualizarTabla ={this.showList}
                    open={this.state.abrirModalAceptarSolicitud}   
                    controller={this.state.controller}
                    fotosVieneVacio={this.state.fotosVieneVacio}
                    mensajeFotosVieneVacio={this.state.mensajeFotosVieneVacio}
                    handleClose={this.CerrarModalSolicitudEmpadronamientoModal}
                />

                <AutorizarSolicitudesEmpadronamientoExtranjero
                    actualizarTabla={this.closeModalForNewCensusRegistration}
                    open={this.state.showModalNewCensusRegistration}   
                    controller={this.state.controller}
                    handleClose={this.closeModalForNewCensusRegistration}
                    actualizarTabla={this.showList}
                />

                {window.screen.width >= 1024 ? (
                    <Table  pageSize={this.state.pageSize} 
                            service={ApiServices[this.state.controller]}
                            title={"Listado de solicitudes nuevas"}
                            header = {this.state.header}                             
                            refreshList={this.showList}
                            detailPanel={this.state.detailPanel}
                            showSearcher={true}
                            // searchList={[un array del header personalizado]}
                            addRegister={this.openModalForNewCensusRegistration} 
                    />
                ) : ("") }
                <br/><br/><br/><Footer />
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SolicitudesNuevasExtranjero);